import withRoot from '../../withRoot';
import React, {useState, useEffect, Fragment, useContext} from 'react';
import {
    Button,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    Slide, Snackbar,
} from '@material-ui/core';
import {Table, Popover, Dropdown, Whisper} from 'rsuite';
import Axios from "axios";
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import TextField from "@material-ui/core/TextField/TextField";
import {gql, useLazyQuery, useMutation} from "@apollo/client";
import {useFormik} from "formik";
import * as yup from 'yup';
import {makeStyles} from "@material-ui/core/styles";
import Loading from "../../Loading";
import SearchIcon from "@material-ui/icons/Search";
import Alert from "@material-ui/lab/Alert";
import authContext from "../../../context/AuthContext";

const validationSchema = yup.object({
    numeroPoliza: yup
        .string('Ingrese el número de póliza')
        .min(7, 'La póliza debe tener al menos 7 números')
        .required('Ingrese un número valido'),
});
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const {Column, HeaderCell, Cell, Pagination} = Table;


const GET_EMISIONES = gql`
    query MyQuery {
        Microseguros_Emisiones(where: {environment: {_eq: "pro"}, Estado: {_neq: "Cancel"}}, order_by: {created_at: desc}) {
            AfinidadInfo {
                Nombre
            }
            Estado
            FormaDePago
            NumeroPoliza
            NumeroRefencia
            NumeroTramite
            idEmision
            emision_clientes {
                Cliente {
                    dni
                    apellido
                    nombre
                }
            }
            Direccion
        }
    }

`;

const CONFIRMAR_EMISION_MICROSEGURO = gql`
    mutation confirmarEmisionMicroseguro($id: Int!, $numPoliza: String!) {
        update_Microseguros_Emisiones(where: {idEmision: {_eq: $id}}, _set: {Estado: "Success", NumeroPoliza: $numPoliza}) {
            affected_rows
        }
    }
`;

// const CANCELAR_EMISION_MICROSEGURO = gql`
//     mutation cancelarEmisionMicroseguros($id: Int!) {
//         update_Microseguros_Emisiones(where: {idEmision: {_eq: $id}}, _set: {Estado: "Cancel"}) {
//             affected_rows
//         }
//     }`;

const useStyles = makeStyles(theme => ({
    table: {
        marginTop: theme.spacing(3),
        backgroundColor: "#fff",
        borderRadius: "20px",
        boxShadow: "5px 10px 18px #888888",
        padding: "30px",
        position: "relative"
    },
    alertField: {
        '& label.Mui-focused': {
            color: "#BB0D66",
        },
    },
    alertTitle: {
        fontFamily: "EncodeSansBold",
        color: "#BB0D66",
        fontSize: "18px"
    },
    alertSubTitle: {
        fontFamily: "EncodeSansBold",
        color: "#000",
        lineHeight: 0.5,
        fontSize: "16px"
    },
    alertText: {
        fontFamily: "EncodeSansRegular",
        color: "#000",
        fontSize: "16px"
    },
    buttons: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        width: "100%",
        padding: "8px 0px"
    },
    buttonConfirm: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#BB0D66",
        marginLeft: "5px",
        marginRight: "5px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    buttonCancel: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#9A9A9A",
        marginLeft: "5px",
        marginRight: "5px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    centerVertically: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center",
    },
    endHorizontally: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "flex-end",
        alignItems: "center",
    },
    snackBar: {
        backgroundColor: theme.palette.warning.dark
    },
    loadingDiv: {
        position: "absolute",
        top: 0,
        zIndex: 2,
        width: "100%",
        height: "100%",
        left: 0,
        right: 0,

    }
}))

const NameCell = ({rowData, dataKey, ...props}) => {
    switch (dataKey) {
        case 'AfinidadNombre':
            return (
                <Cell {...props}>
                    {rowData.AfinidadInfo[0].Nombre}
                </Cell>
            );
        case 'ClienteNombre':
            return (
                <Cell {...props}>
                    {rowData.emision_clientes[0].Cliente.nombre + " " + rowData.emision_clientes[0].Cliente.apellido}
                </Cell>
            );
        case 'DNI':
            return (
                <Cell {...props}>
                    {rowData.emision_clientes[0].Cliente.dni}
                </Cell>
            );
    }
};

function TablaEmisionesMicroseguro() {
    const classes = useStyles();

    //GET
    const [getEmisionesData, {data: emisionesData}] = useLazyQuery(GET_EMISIONES, {
        fetchPolicy: 'network-only',
    });


    //SNACKBAR ALERT
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [alertMessageSnackBar, setAlertMessageSnackBar] = useState(null);

    //DIALOG
    const [id, setId] = useState('');
    const [tramite, setTramite] = useState('');
    const [filteredEmisiones, setFilteredEmisiones] = useState(null);
    const [rows, setRows] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);

    //ALERT DELETE
    const [openAlertDelete, setOpenAlertDelete] = useState(false);
    const handleCloseAlertDelete = () => {
        setOpenAlertDelete(false);
    };

    //PAGINATION
    const [page, setPage] = useState(1);
    const [displayLength, setDisplayLength] = useState(10);


    const handleOpenAlertDelete = (row) => {
        setId(row.idEmision);
        setTramite(row.NumeroTramite);
        setOpenAlertDelete(true);
    };

    //ALERT CONFIRM
    const [openAlertConfirm, setOpenAlertConfirm] = useState(false);
    const handleCloseAlertConfirm = () => {
        setOpenAlertConfirm(false);
    };
    const handleOpenAlertConfirm = (row) => {
        setId(row.idEmision);
        setTramite(row.NumeroTramite);
        setOpenAlertConfirm(true);
    };

    //CONFIRM AND CANCEL
    const [confirmarEmisionMicroseguro] = useMutation(CONFIRMAR_EMISION_MICROSEGURO);
    // const [cancelarEmisionMicroseguro] = useMutation(CANCELAR_EMISION_MICROSEGURO);
    const formik = useFormik({
        initialValues: {
            numeroPoliza: '',
        },
        validationSchema: validationSchema,
        onSubmit: (numeroPoliza) => {
            confirmarEmisionMicroseguro({variables: {id: id, numPoliza: numeroPoliza.numeroPoliza}}).then(() => {
                    setRows(null);
                    setOpenAlertConfirm(false);
                    getEmisionesData();
                }
            )

        },
    });

    //SEARCH
    const handleSearchValueChange = (event) => {
        if (event.target.value.length >= 3) {
            let filtered = rows.filter((item) =>
                item["Direccion"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["emision_clientes"][0]["Cliente"]["apellido"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["NumeroRefencia"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["NumeroTramite"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["emision_clientes"][0]["Cliente"]["nombre"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["AfinidadInfo"][0]["Nombre"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["emision_clientes"][0]["Cliente"]["dni"].toUpperCase().includes(event.target.value.toUpperCase())
            );
            setFilteredEmisiones(filtered);
        } else setFilteredEmisiones(null)
    };

    //DOWNLOAD
    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null
    };

    const {authToken} = useContext(authContext)

    const handleDownload = (option, rowData) => {
        setIsDownloading(true)
        let url = process.env.REACT_APP_BACK_SERVER + '/documentacion/Combinado';
        let body = {
            "origen": 'affinity',
            "document": option,
            "officialNumber": rowData['NumeroPoliza'],
            "referenceNumber": rowData['NumeroRefencia']
        };
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        };
        Axios.post(url, body, {headers: headers}
        ).then(res => {
            openInNewTab(res.data)
            setIsDownloading(false)
        }).catch(err => {
            setOpenSnackBar(true)
            setAlertMessageSnackBar("Ha ocurrido un error, intente más tarde")
            setIsDownloading(false)
        });
    };

    //TABLE RENDER
    const renderMenu = (rowData) => {
        const handleSelect = eventKey => {
            switch (eventKey) {
                case 0:
                    handleOpenAlertConfirm(rowData)
                    break;
                case 1:
                    handleOpenAlertDelete(rowData)
                    break;
                case 2.1:
                    handleDownload("Caratula", rowData);
                    break;
                case 2.2:
                    handleDownload("ReciboConCodigoDeBarra", rowData);
                    break;
                case 2.3:
                    handleDownload("Factura", rowData);
                    break;
                case 2.4:
                    handleDownload("ConstanciaDeCoberturaPE", rowData);
                    break;
                case 2.5:
                    handleDownload("ConstanciaCoberturaRC", rowData);
                    break;
            }

        };
        if (rowData.Estado === 'Success')
            return (
                <Popover full>
                    <Dropdown.Menu placement="bottomStart" onSelect={handleSelect}>
                        {/*<Dropdown.Item eventKey={1}>Cancelar</Dropdown.Item>*/}
                        {/*<Dropdown.Item divider/>*/}
                        <Dropdown.Menu title="Descargar">
                            <Dropdown.Item eventKey={2.1}>Póliza</Dropdown.Item>
                            {rowData.FormaDePago === "0" //Efectivo
                                ? <Dropdown.Item eventKey={2.2}>Cupón de Pago</Dropdown.Item>
                                : <Dropdown.Item eventKey={2.3}>Factura</Dropdown.Item>}
                            <Dropdown.Item eventKey={2.4}>Certificado de Cobertura</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown.Menu>

                </Popover>
            );
        else
            return (
                <Popover full>
                    <Dropdown.Menu placement="bottomStart" onSelect={handleSelect}>
                        <Dropdown.Item eventKey={0}>Confirmar</Dropdown.Item>
                        {/*<Dropdown.Item eventKey={1}>Cancelar</Dropdown.Item>*/}
                        <Dropdown.Item divider/>
                        <Dropdown.Menu title="Descargar">
                            <Dropdown.Item eventKey={2.5}>Certificado de Cobertura Provisoria</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown.Menu>

                </Popover>
            );
    };

    const ActionCell = ({rowData, dataKey, ...props}) => {
            return (
                <Cell {...props} className="link-group">
                    <Whisper placement="autoVerticalStart" trigger="click" speaker={renderMenu(rowData)}>
                        <ArrowDropDownCircleIcon style={{color: "#BB0D66", cursor: "pointer"}}/>
                    </Whisper>
                </Cell>
            );
        }
    ;
    const getData = () => {
        return rows.filter((v, i) => {
            const start = displayLength * (page - 1);
            const end = start + displayLength;
            return i >= start && i < end;
        });
    };

    useEffect(() => {
        if (emisionesData === undefined) {
            getEmisionesData()
        } else if (emisionesData) {
            if (filteredEmisiones === null) {
                setRows(emisionesData["Microseguros_Emisiones"]);
            } else
                setRows(filteredEmisiones);
        }
    }, [filteredEmisiones, emisionesData]);

    if (!rows) return (<Loading/>);
    return (
        <Fragment>
            <div className={classes.table}>
                <div className={classes.endHorizontally} style={{marginRight: "48px", padding: "8px 0px"}}>
                    <div className={classes.centerVertically} style={{marginRight: "8px"}}><SearchIcon
                        style={{color: "#BB0D66"}}/></div>
                    <div className={classes.centerVertically} style={{marginTop: "-24px"}}>
                        <TextField
                            label="Buscar"
                            className={classes.alertField}
                            onChange={(e) => handleSearchValueChange(e)}/>
                    </div>
                </div>
                <Table
                    height={400}
                    width={980}
                    data={getData()}
                    style={{filter: isDownloading ? 'blur(3px)' : 'none'}}
                >
                    <Column fixed width={50} align="center">
                        <HeaderCell>ID</HeaderCell>
                        <Cell dataKey="idEmision"/>
                    </Column>
                    <Column width={100}>
                        <HeaderCell>Estado</HeaderCell>
                        <Cell dataKey="Estado"/>
                    </Column>
                    <Column width={100}>
                        <HeaderCell>Afinidad</HeaderCell>
                        <NameCell dataKey="AfinidadNombre"/>
                    </Column>

                    <Column width={120}>
                        <HeaderCell>N° de referencia</HeaderCell>
                        <Cell dataKey="NumeroRefencia"/>
                    </Column>
                    <Column width={200}>
                        <HeaderCell>N° de trámite</HeaderCell>
                        <Cell dataKey="NumeroTramite"/>
                    </Column>
                    <Column width={200}>
                        <HeaderCell>Dirección</HeaderCell>
                        <Cell dataKey="Direccion"/>
                    </Column>
                    <Column width={100}>
                        <HeaderCell>DNI</HeaderCell>
                        <NameCell dataKey="DNI"/>
                    </Column>
                    <Column width={200}>
                        <HeaderCell>Nombre</HeaderCell>
                        <NameCell dataKey="ClienteNombre"/>
                    </Column>
                    <Column width={70} align="center" fixed="right">
                        <HeaderCell>Opciones</HeaderCell>
                        <ActionCell dataKey="id"/>
                    </Column>
                </Table>
                <div style={{padding: 20}}>
                    <Pagination
                        lengthMenu={[
                            {
                                value: 10,
                                label: 10
                            },
                            {
                                value: 20,
                                label: 20
                            }
                        ]}
                        activePage={page}
                        displayLength={displayLength}
                        total={rows.length}
                        onChangePage={(dataKey) => setPage(dataKey)}
                        onChangeLength={(dataKey) => setDisplayLength(dataKey)}
                    />
                </div>
                {/*{openAlertDelete && (*/}
                {/*    <Dialog*/}
                {/*        open={openAlertDelete}*/}
                {/*        TransitionComponent={Transition}*/}
                {/*        keepMounted*/}
                {/*        onClose={handleCloseAlertDelete}*/}
                {/*    >*/}
                {/*        <DialogTitle>*/}
                {/*            <p className={classes.alertTitle}>Cancelar Emisión</p>*/}
                {/*        </DialogTitle>*/}
                {/*        <DialogContent>*/}
                {/*            <DialogContentText>*/}
                {/*                <p className={classes.alertSubTitle}>ID Emisión seleccionado: <span*/}
                {/*                    className={classes.alertText}>{id}</span></p>*/}
                {/*                <br/>*/}
                {/*                <p className={classes.alertSubTitle}>Número de referencia: <span*/}
                {/*                    className={classes.alertText}>{tramite}</span></p>*/}
                {/*            </DialogContentText>*/}
                {/*        </DialogContent>*/}
                {/*        <DialogActions>*/}
                {/*            <div className={classes.buttons}>*/}
                {/*                <Button onClick={() => setOpenAlertDelete(false)} className={classes.buttonCancel}>*/}
                {/*                    Atrás*/}
                {/*                </Button>*/}
                {/*                <Button onClick={() => {*/}
                {/*                    cancelarEmisionMicroseguro({variables: {id: id}})*/}
                {/*                    setOpenAlertDelete(false)*/}
                {/*                    window.location.reload();*/}
                {/*                }} color="primary" className={classes.buttonConfirm}>*/}
                {/*                    Cancelar Emisión*/}
                {/*                </Button>*/}
                {/*            </div>*/}
                {/*        </DialogActions>*/}
                {/*    </Dialog>*/}
                {/*)}*/}

                {openAlertConfirm && (
                    <Dialog open={openAlertConfirm} onClose={handleCloseAlertConfirm}
                            aria-labelledby="form-dialog-title">
                        <DialogTitle>
                            <p className={classes.alertTitle}>Confirmar Emisión</p>
                        </DialogTitle>
                        <form onSubmit={formik.handleSubmit}>
                            <DialogContent>
                                <DialogContentText>
                                    <p className={classes.alertSubTitle}>ID Emisión seleccionado: <span
                                        className={classes.alertText}>{id}</span></p>
                                    <br/>
                                    <p className={classes.alertSubTitle}>Número de referencia: <span
                                        className={classes.alertText}>{tramite}</span></p>
                                </DialogContentText>

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    className={classes.alertField}
                                    name="numeroPoliza"
                                    label="Número de Póliza"
                                    type="numeroPoliza"
                                    fullWidth
                                    value={formik.values.numeroPoliza}
                                    error={formik.touched.numeroPoliza && Boolean(formik.errors.numeroPoliza)}
                                    helperText={formik.touched.numeroPoliza && formik.errors.numeroPoliza}
                                    onChange={formik.handleChange}
                                />

                            </DialogContent>
                            <DialogActions>
                                <div className={classes.buttons}>
                                    <Button onClick={handleCloseAlertConfirm} className={classes.buttonCancel}>
                                        Atrás
                                    </Button>
                                    <Button type="submit"
                                            className={classes.buttonConfirm}>
                                        Confirmar Emisión
                                    </Button>
                                </div>
                            </DialogActions>
                        </form>
                    </Dialog>
                )}
                {isDownloading &&
                <div className={classes.loadingDiv}><Loading/></div>}
                <Snackbar open={openSnackBar && alertMessageSnackBar} autoHideDuration={5000} onClose={() => {
                    setOpenSnackBar(false);
                    setAlertMessageSnackBar(null);
                }}>
                    <Alert onClose={() => {
                        setOpenSnackBar(false);
                        setAlertMessageSnackBar(null);
                    }} severity="warning" elevation={6} variant="filled"
                           classes={{filledWarning: classes.snackBar}}
                    >
                        {alertMessageSnackBar}
                    </Alert>
                </Snackbar>
            </div>
        </Fragment>
    )
}

export default withRoot(TablaEmisionesMicroseguro);
